"use client"

import { useEffect, useState, useCallback } from "react"
import { supabase } from "../../supabaseClient"
import { useAuth } from "../../context/AuthContext"
import { applyInstitutionFilter } from "../../lib/tenant"
import "../../styles/CursoList.css"

export default function CursoList({ keyProp, onEdit }) {
  const { isAdmin, instituicaoId } = useAuth()
  const [cursos, setCursos] = useState([])
  const [loading, setLoading] = useState(true)

  const fetchCursos = useCallback(async () => {
    setLoading(true)
    try {
      let query = supabase
        .from("cursos")
        .select(`
          *,
          departamento:departamento_id(id, nome)
        `)
        .order("nome", { ascending: true })
      
      query = applyInstitutionFilter(query, isAdmin, instituicaoId)
      const { data, error } = await query
      if (error) throw error
      setCursos(data || [])
    } catch (err) {
      console.error("Erro ao buscar cursos:", err.message)
    } finally {
      setLoading(false)
    }
  }, [isAdmin, instituicaoId])

  useEffect(() => {
    fetchCursos()
  }, [keyProp, fetchCursos])

  const handleDelete = async (curso) => {
    if (!window.confirm(`Tem certeza que deseja excluir o curso "${curso.nome}"?`)) {
      return
    }

    try {
      // Verificar se há turmas usando este curso
      const { data: turmasUsando } = await supabase.from("turmas").select("id").eq("curso_id", curso.id)

      if (turmasUsando && turmasUsando.length > 0) {
        const confirmar = window.confirm(
          `Este curso está associado a ${turmasUsando.length} turma(s). Deseja remover a associação e excluir o curso?`,
        )
        if (!confirmar) return

        // Remover associação com turmas
        await supabase.from("turmas").update({ curso_id: null }).eq("curso_id", curso.id)
      }

      // Verificar se há professores usando este curso
      const { data: profsUsando } = await supabase.from("professores").select("id").eq("curso_id", curso.id)

      if (profsUsando && profsUsando.length > 0) {
        // Remover associação com professores
        await supabase.from("professores").update({ curso_id: null }).eq("curso_id", curso.id)
      }

      // Deletar curso
      const { error } = await supabase.from("cursos").delete().eq("id", curso.id)

      if (error) throw error

      alert("Curso excluído com sucesso!")
      fetchCursos()
    } catch (err) {
      console.error("Erro ao excluir curso:", err.message)
      alert("Erro ao excluir curso: " + err.message)
    }
  }

  if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
        <p>Carregando cursos...</p>
      </div>
    )
  }

  if (!cursos.length) {
    return (
      <div className="empty-state">
        <p>Nenhum curso cadastrado.</p>
      </div>
    )
  }

  return (
    <div className="curso-list-container">
      <h3 className="list-title">Cursos Cadastrados</h3>

      <div className="cards-grid">
        {cursos.map((curso) => (
          <div key={curso.id} className="curso-card">
            <div className="card-header">
              <h3 className="curso-nome">{curso.nome}</h3>
            </div>

            <div className="card-body">
              {curso.departamento?.nome && (
                <div className="info-row">
                  <span className="info-label">Departamento:</span>
                  <span className="info-value">{curso.departamento.nome}</span>
                </div>
              )}
            </div>

            <div className="card-actions">
              <button className="btn-editar" onClick={() => onEdit && onEdit(curso)}>
                Editar
              </button>
              <button className="btn-excluir" onClick={() => handleDelete(curso)}>
                Excluir
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
